<script>
    import { createEventDispatcher, onMount } from "svelte";
    import { deleteField } from "firebase/firestore";
    import Period from "./Period.svelte";
    import Fa from "svelte-fa";
    import { faCircleArrowUp, faPlus, faRepeat, faTrash } from "@fortawesome/free-solid-svg-icons";

    export let periods = [];
    export let day;
    export let date;
    export let year;
    let annual;

    const currentYear = JSON.stringify(new Date().getFullYear());
    const dispatch = createEventDispatcher();

    onMount(() => {
        if (year == "annual") {
            annual = true;
        }
    });

    function deleteDay() {
        dispatch("remove", {date})
    }

    function addPeriod() {
        periods.push({open: {day, time: "0900"}, close: {day, time: "1800"}});
        periods = periods;
    }

    function deletePeriod(e) {
        console.log(e.detail.period);
        periods = periods.filter(period => period != e.detail.period);
        periods = periods;
    }

    function toggleAnnual() {
        annual = !annual;
        year = annual?"annual":currentYear;
    }
    
    function formatDate (mmdd, year) {
        if (!(typeof mmdd == "string")){
            console.warn("Zu formatierendes Datum ist nicht vom Typ String.")
            return;
        }
        if (year == "annual") {
            return (mmdd.slice(2, 4)+"."+mmdd.slice(0, 2)+"."+currentYear);
        }
        return (mmdd.slice(2, 4)+"."+mmdd.slice(0, 2)+"."+year);
    }
</script>

<div class="container">
    <button class="delete" on:click={deleteDay}><Fa icon={faTrash}/></button>
    <!-- <input bind:checked={annual} type="checkbox" class="checkbox" id={name}> -->
    <span class="day">{formatDate(date, year)}</span>
    <button class="annual" class:active={annual} type="checkbox" title="Jährlich wiederkehrend" on:click={toggleAnnual}>
        <Fa icon={faRepeat}/>
    </button>
    {#if periods.length > 0}
        <div class="periods">
            {#each periods as period}
            <Period bind:period on:delete={deletePeriod}/>
            {/each}
        </div>
    {:else}
    <i class="closed">geschlossen</i>
    {/if}
    <button on:click={addPeriod} class="new"><Fa icon={faPlus}/></button>
</div>

<style>
    .container {
        display: grid;
        grid-template-columns: [delete] 2rem [day] 10ch [annual] 2rem [slots] auto [new] 2rem [end];
        grid-template-rows: auto;
        margin-bottom: 1rem;
    }

    .delete {
        grid-area: delete;
        margin-bottom: 0;
        width: 1.5rem;
        height: 1.5rem;
        padding: 0;
    }

    .day {
        grid-area: day;
    }
    
    .annual {
        grid-area: annual;
        margin-bottom: 0;
        width: 1.5rem;
        height: 1.5rem;
        padding: 0;
        filter: grayscale(1) opacity(0.5);
    }
    
    .annual.active {
        filter: grayscale(0) opacity(1);
    }

    .periods {
        grid-area: slots;
    }
    
    .new {
        grid-area: new;
    }

    .closed {
        grid-area: slots;
    }
</style>